import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'p8-bdc-add-block-button',
  templateUrl: './add-block-button.component.html',
  styleUrls: ['./add-block-button.component.scss']
})
export class AddBlockButtonComponent implements OnInit {
  @Output() newBlock: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  addBlock(type: string) {
    this.newBlock.emit({type: type});
  }
}
